import React, { FC } from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import * as Styles from './_confirmStockoutTransactionsModal.module.scss';

type ConfirmStockoutTransactionsModalProps = {
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
}

const ConfirmStockoutTransactionsModal: FC<ConfirmStockoutTransactionsModalProps> = ({
    isOpen,
    onClose,
    isLoading,
}) => {
    const dispatch = useAppDispatch();

    const stockOutTransactionsListing = useAppSelector(state => state.gold.goldInventory.inventoryStockOutTransactionsListing);

    const {
        affectedTransactions,
        affectedEarmarks,
        affectedConversions,
        affectedCollaterals,
        affectedEarmarkConversions,
    } = stockOutTransactionsListing;

    const handleConfirmStockOut = () => {
        onClose();

        dispatch(
            combinedActions.goldCreateStockOutAttempt()
        );
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title='Affected Transactions'
        >
            <div>
                <Text
                    label='Confirm create stock out? Once proceed all transactions will be rejected. The following will be affected:'
                />

                {affectedTransactions.length > 0 && (
                    <div className={Styles['section']}>
                        <Text isBold label='Transactions' />
                        {affectedTransactions.map((transaction) => (
                            <Text
                                key={transaction.transactionId}
                                label={`Transaction ID: ${transaction.transactionId}`}
                            />
                        ))}
                    </div>
                )}

                {affectedEarmarks.length > 0 && (
                    <div className={Styles['section']}>
                        <Text isBold label='Earmarks' />
                        {affectedEarmarks.map((earmark) => (
                            <Text
                                key={earmark.transactionId}
                                label={`Transaction ID: ${earmark.transactionId}`}
                            />
                        ))}
                    </div>
                )}

                {affectedConversions.length > 0 && (
                    <div className={Styles['section']}>
                        <Text isBold label='Conversions' />
                        {affectedConversions.map((conversion) => (
                            <Text
                                key={conversion.conversionId}
                                label={`Conversion ID: ${conversion.conversionId}`}
                            />
                        ))}
                    </div>
                )}

                {affectedCollaterals.length > 0 && (
                    <div className={Styles['section']}>
                        <Text isBold label='Collaterals' />
                        {affectedCollaterals.map((collateral) => (
                            <Text
                                key={collateral.collateralId}
                                label={`Collateral ID: ${collateral.collateralId}`}
                            />
                        ))}
                    </div>
                )}

                {affectedEarmarkConversions.length > 0 && (
                    <div className={Styles['section']}>
                        <Text isBold label='Earmark Conversions' />
                        {affectedEarmarkConversions.map((collateral) => (
                            <Text
                                key={collateral.earmarkConversionId}
                                label={`Earmark Conversion ID: ${collateral.earmarkConversionId}`}
                            />
                        ))}
                    </div>
                )}
            </div>

            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={onClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label='Confirm'
                    onClick={handleConfirmStockOut}
                    isLoading={isLoading}
                    disabled={isLoading}
                />
            </div>
        </Modal>
    );
};

export default ConfirmStockoutTransactionsModal;
